<template>
  <div class="s-sidebar">
    <a
      class="s-sidebar__button"
      href
      @click.prevent="showSidebar(true)"
    >
      <span class="material-icons-round">{{ icon }}</span>
    </a>
    <transition name="fade">
      <div
        v-show="show"
        class="s-sidebar__backdrop modal-backdrop"
        @click="showSidebar(false, true)"
      ></div>
    </transition>
    <transition name="slide">
      <div
        v-show="show"
        class="s-sidebar__container"
      >
        <div class="s-sidebar__header">
          <h3 class="s-sidebar__title h2 mb-3">
            <span>{{ title }}</span>
            <a
              class="material-icons-round s-sidebar__title-button-close"
              href
              @click.prevent="showSidebar(false, true)"
            >
              close
            </a>
          </h3>
        </div>
        <b-row class="s-sidebar__slots">
          <b-col class="position-relative">
            <div class="s-sidebar__content">
              <b-row class="s-sidebar__body">
                <b-col>
                  <slot name="body"></slot>
                </b-col>
              </b-row>
              <b-row class="s-sidebar__footer">
                <b-col>
                  <slot name="footer"></slot>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    titleLabel: {
      type: String,
      default: 'actions.filter',
    },
    icon: {
      type: String,
      default: 'filter_alt',
    },
  },
  data: () => ({
    show: false,
  }),
  computed: {
    title() {
      return this.$t(this.titleLabel);
    },
  },
  methods: {
    showSidebar(value, isCloseAndCancel = false) {
      this.show = value;

      if (value === true) {
        this.$emit('on-show');
      }

      if (value === false && !isCloseAndCancel) {
        this.$emit('on-hide');
      }

      if (value === false && isCloseAndCancel) {
        this.$emit('on-cancel');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep
  .modal-backdrop
    z-index: 1038

  & .multiselect__tags-wrap
    overflow-x: hidden

.s-sidebar
  overflow: hidden

  &__button
    .material-icons-round
      color: var(--color-icons)

  &__container
    position: fixed
    display: flex
    flex-flow: column
    width: 100%
    height: 100%
    max-width: 480px
    top: 0
    right: 0
    padding: 1.5rem
    outline: 0
    background-color: var(--color-page-filter-background)
    overflow: hidden
    z-index: 1039

  &__header
    flex: 0 1 auto

  &__title
    position: relative
    padding-right: 2rem

    &-button-close
      position: absolute
      right: 0
      cursor: pointer

  &__slots
    overflow: auto
    flex: 1 1 auto

  &__content
    position: absolute
    display: flex
    -webkit-box-orient: vertical
    -webkit-box-direction: normal
    flex-flow: column
    width: calc(100% - 30px)
    height: 100%

  &__body
    flex-grow: 1
    overflow-y: auto

  &__footer
    margin-top: 1rem

    .col
      display: flex
      justify-content: flex-end

  ::v-deep
    .period-date-select__form-wrapper
      flex-direction: column

    .period-date-select__range,
    .period-date-select__dates
      flex: 1
      max-width: 100%

    .period-date-select__range
      margin-bottom: 1.5rem !important


.fade-leave-active,
.fade-enter-active
  transition: opacity .6s

.fade-enter, .fade-leave-to
  opacity: 0

.slide-leave-active,
.slide-enter-active
  transition: .8s

.slide-enter
  transform: translate(100%, 0)

.slide-leave-to
  transform: translate(100%, 0)

</style>

